<template>
  <v-row class="my-0 py-0">
    <v-col cols="12" md="9">
      <v-text-field
          v-model="name"
          dense
          class="rounded-r-0 rounded-l-lg"
          hide-details="auto"
          outlined
          label="Название"></v-text-field>
    </v-col>
    <v-col cols="12" md="3">
      <v-text-field
          v-model="score"
          dense
          class="rounded-l-0 rounded-r-lg"
          hide-details="auto"
          type="number"
          step="0.5"
          @blur="blurInput"
          @mouseup="focusInput"
          outlined
          label="Баллы"
      >
        <template #append-outer>
          <v-icon
              :color="$store.state.achievement.btn_color"
              @click="deleteSubunit({indexUnit: indexUnit, indexSubunit: indexSubunit})" small
          >
            fa fa-trash
          </v-icon>
          <div class="mx-1"/>
          <v-icon
              small
              :color="$store.state.achievement.btn_color"
              @click="toggleHiddenAchievementSubunit({unitId: unitId, subunitId: subunit.id})"
              v-show="!isNew(subunit)"
          >
            {{!subunit.is_hidden ? "fa fa-eye" : "fa-eye-slash"}}
          </v-icon>
        </template>
      </v-text-field>
    </v-col>
    <!--      <v-divider v-show="$vuetify.breakpoint.xsOnly"/>-->
  </v-row>
</template>

<script>
import {mapActions, mapMutations} from "vuex";
import fieldAchievementFocusMixins from "../../mixins/fieldAchievementFocusMixins";

export default {
  name: "SubunitLevelTextField",
  mixins: [fieldAchievementFocusMixins],
  props: {
    subunit: Object,
    indexUnit:Number,
    indexSubunit: Number,
    unitId: Number,
  },
  data() {
    return {
      name: this.subunit.name,
      score: this.subunit.score
    }
  },
  watch: {
    name(newValue) {
      this.updateSubunit()
    },
    score(newValue) {
      this.updateSubunit()
    }
  },
  methods: {
    ...mapMutations({
      updateSubunitData: 'achievement_kind/updateSubunitData',
      deleteSubunit: 'achievement_kind/deleteSubunit',
    }),
    ...mapActions({
      toggleHiddenAchievementSubunit: 'achievement_kind/toggleHiddenAchievementSubunit',
    }),

    updateSubunit() {
      this.updateSubunitData({
        indexUnit: this.indexUnit,
        indexSubunit: this.indexSubunit,
        name: this.name,
        score: this.score
      })
    },

    isNew(subunit) {
      return subunit?.id == null
    }
  }
}
</script>

<style scoped>

</style>